import { createTheme } from "@mui/material";

// Create a custom theme based on CONAS logo colors (navy blue and green)
export const conasTheme = createTheme({
  palette: {
    primary: {
      main: "#002A5B", // Navy blue from logo
      light: "#1E4D7B",
      dark: "#001F43",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#7AC142", // Green from logo
      light: "#94D165",
      dark: "#62A931",
      contrastText: "#000000",
    },
    background: {
      default: "#F5F7F9",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#333333",
      secondary: "#666666",
    },
    divider: "#DDDDDD",
    // Custom color for hover effects
    action: {
      hover: "rgba(122, 193, 66, 0.08)",
      selected: "rgba(122, 193, 66, 0.16)",
    },
    error: {
      main: "#FF0000", // Red color for error states
    },
    warning: {
      main: "#FFC107", // Yellow color for warning states
    },
    success: {
      main: "#4CAF50", // Green color for success states
    },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          backgroundColor: "#002A5B",
          color: "#FFFFFF",
          "&:hover": {
            backgroundColor: "#1E4D7B",
          },
        },
        outlinedPrimary: {
          borderColor: "#002A5B",
          color: "#002A5B",
          "&:hover": {
            borderColor: "#1E4D7B",
            backgroundColor: "rgba(0, 42, 91, 0.04)",
          },
        },
        containedSecondary: {
          backgroundColor: "#7AC142",
          color: "#000000",
          "&:hover": {
            backgroundColor: "#62A931",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "#002A5B",
          color: "#FFFFFF",
          fontWeight: "bold",
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#CCCCCC",
          "&.Mui-active": {
            color: "#7AC142",
          },
          "&.Mui-completed": {
            color: "#002A5B",
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#7AC142",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: "#002A5B",
            fontWeight: "bold",
          },
        },
      },
    },
  },
});

export default conasTheme;